import React, {useEffect, useState} from 'react';
import styles from './index.module.scss'
import Footer from '../../components/footer'
import NavbarMenus from '../../components/navbarMenus'
import Anchor from '../../components/anchor'
import Header from '../../components/header'
import ModuleCode from '../../components/module'
import { Image, Alert, Table } from 'antd';
import defBar from '../../static/image/defBar.gif'
import updateBar from '../../static/image/updateBar.gif'
import xBar from '../../static/image/xBar.gif'
import yBar from '../../static/image/yBar.gif'
import legendBar from '../../static/image/legendBar.gif'
import tooltipBar from '../../static/image/tooltipBar.gif'
import cTooltipBar from '../../static/image/cTooltipBar.gif'
import seriesBar from '../../static/image/seriesBar.gif'
import dataZoomBar from '../../static/image/dataZoomBar.gif'
import {
    defCode,
    changeCode,
    xAxisCode,
    yAxisCode,
    twoYAxisCode,
    yAxisMinMaxDefOption,
    legendCode,
    tooltipCode,
    tooltipCustomCode,
    seriesCode,
    seriesSelectCode,
    seriesGradientOption,
    stackSeriesOption,
    seriesRadiusOption,
    columns,
    commonData,
    legendData,
    tooltipData,
    dataZoomCode,
    dataZoomData,
    xAxisData,
    yAxisData,
    seriesData,
    anchorItems
} from './mock'

const GettingStarted = () => {
    return (
        <div className={styles.modules}>
             <div className={styles.navbar} id='nav'>
                <NavbarMenus path="McBarChart"></NavbarMenus>
            </div>
            <div className={styles.view} id='chartView'>
                <Header title='McBarChart（柱状图）'></Header>
                <div className={styles.module}>
                    <Alert
                        message="温馨提示"
                        description="由于本组件基于ArkTS封装，导致无法在浏览器页面实时预览，所以代码效果图是图片，想要实时预览即可复制代码到对应项目；如若给您带来不便，我们深感歉意；感谢使用。"
                        type="warning"
                        showIcon
                    />
                </div>
                <ModuleCode title={'默认'}
                            tips={'- McBarChart（柱状图）作为图表中最常见之一的图表，可以通过以下代码实现系统默认的柱状图。需要注意的是：横向柱状图的xAxis代表就是yAxis，而yAxis代表是xAxis'}
                            code={defCode} imgUrl={defBar}
                            apiTitle={'基础属性'}
                            columns={columns} dataSource={commonData}></ModuleCode>

                <ModuleCode title={'动态更新数据'}
                            tips={'- McCharts 组件整体使用@Observed装饰器和@ObjectLink装饰器来监控数据的变化，所以修改数据需要使用Option实例对象的setVal方法来实现'}
                            code={changeCode} imgUrl={updateBar}></ModuleCode>


                <ModuleCode title={'xAxis属性'}
                            tips={'- McBarChart（柱状图）支持通过xAxis中的属性来设置X轴的相关样式与功能，其中包含：轴线颜色、刻度线的配置、字体大小、字体样式、字体颜色等等。详细也可以快速查看属性表'}
                            code={xAxisCode} imgUrl={xBar}
                            apiTitle={'xAxis属性'}
                            columns={columns} dataSource={xAxisData}></ModuleCode>

                <ModuleCode title={'yAxis属性'}
                            tips={'- McBarChart（柱状图）支持通过yAxis中的属性来设置Y轴的相关样式与功能，其中包含：轴线颜色、刻度线的配置、字体大小、字体样式、字体颜色等等。详细也可以快速查看属性表'}
                            code={yAxisCode} imgUrl={yBar}
                            apiTitle={'yAxis属性'}
                            columns={columns} dataSource={yAxisData}></ModuleCode>

                <ModuleCode title={'双Y轴案例'}
                            tips={'- McBarChart（柱状图）支持通过yAxis中的属性可以设置多组数据用来实现多条y轴的功能'}
                            code={twoYAxisCode} imgUrl={yBar}
                            apiTitle={'twoYAxisCode属性'}
                ></ModuleCode>

                <ModuleCode title={'Y轴限定范围'}
                            tips={'- McBarChart（柱状图）支持通过yAxis中的属性可以设置Y轴的最大值与最小值'}
                            code={yAxisMinMaxDefOption} imgUrl={yBar}
                            apiTitle={'yAxisMinMaxDefOption属性'}
                ></ModuleCode>

                <ModuleCode title={'legend属性'}
                            tips={'- McBarChart（柱状图）支持通过legend中的属性来设置图例的相关样式与功能，其中包含：图例位置、不同系列图例的距离、字体大小、字体样式、字体颜色等等。详细也可以快速查看属性表'}
                            code={legendCode} imgUrl={legendBar}
                            apiTitle={'legend属性'}
                            columns={columns} dataSource={legendData}></ModuleCode>

                <ModuleCode title={'tooltip属性'}
                            tips={'- McBarChart（柱状图）支持通过tooltip中的属性来设置提示层的相关样式与功能，其中包含：提示层的样式、提示层类型、提示线的配置等等。详细也可以快速查看属性表'}
                            code={tooltipCode} imgUrl={tooltipBar}
                            apiTitle={'tooltip属性'}
                            columns={columns} dataSource={tooltipData}></ModuleCode>

                <ModuleCode title={'自定义tooltip属性'}
                            tips={'- McBarChart（柱状图）支持通过自定义来设置。设置自定义之后，tooltip中的部分属性会失效。'}
                            code={tooltipCustomCode} imgUrl={cTooltipBar}></ModuleCode>

                <ModuleCode title={'dataZoom属性'}
                            tips={'- McBarChart（柱状图）支持通过dataZoom属性来实现区域缩放，可动态设置起始位置与结束位置。完美适配手动滑动与手动捏合缩放的交互。'}
                            code={dataZoomCode} imgUrl={dataZoomBar}
                            apiTitle={'dataZoom属性'}
                            columns={columns} dataSource={dataZoomData}></ModuleCode>

                <ModuleCode title={'series属性'}
                            tips={'- McBarChart（柱状图）支持通过series中的属性来设置柱状区的相关样式与功能，其中包含：柱状颜色、柱状拐点样式、柱状文本标签配置等等。详细也可以快速查看属性表'}
                            code={seriesCode} imgUrl={seriesBar}
                            apiTitle={'series属性'}
                            columns={columns} dataSource={seriesData}></ModuleCode>

                <ModuleCode title={'高亮柱状图'}
                            tips={'- McBarChart（柱状图）支持通过series中的属性来设置高亮指定的柱子'}
                            code={seriesSelectCode} imgUrl={seriesBar}
                            apiTitle={'seriesSelectCode属性'}></ModuleCode>

                <ModuleCode title={'渐变色柱状图'}
                            tips={'- McBarChart（柱状图）支持通过series中的属性来设置渐变色的场景'}
                            apiTitle={'seriesGradient属性'}
                            code={seriesGradientOption} imgUrl={seriesBar}></ModuleCode>

                <ModuleCode title={'圆角柱状图'}
                            tips={'- McBarChart（柱状图）支持通过series中的属性来设置圆角的场景'}
                            apiTitle={'seriesRadius属性'}
                            code={seriesRadiusOption} imgUrl={seriesBar}></ModuleCode>

                <ModuleCode title={'堆叠模式'}
                            tips={'- McBarChart（柱状图）支持通过series中的属性来设置堆叠模式的场景'}
                            apiTitle={'seriesStack属性'}
                            code={stackSeriesOption} imgUrl={seriesBar}></ModuleCode>
                <Footer></Footer>
                <Anchor items={anchorItems}></Anchor>
            </div>
        </div>
    )
}

export default GettingStarted
